import { NgClass } from '@angular/common';
import { Component, OnInit, inject, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'app/shared/service/auth.service';
import { MenuItem, MenuService } from 'app/shared/service/menu.service';
import { environment } from 'environments/environment.prod';
import { filter } from 'rxjs';

@Component({
  selector: 'app-auth-header',
  imports: [MatIconModule, MatMenuModule, NgClass],
  templateUrl: './auth-header.component.html',
  styleUrl: './auth-header.component.scss',
})
export class AuthHeaderComponent implements OnInit {
  private authService = inject(AuthService);
  private menuService = inject(MenuService);
  private router = inject(Router);
  client = window.location.pathname.split('/')[1] === 'apps';
  toggleSidebar = output<void>();
  pageTitle: string = '';
  userName: string;
  isMenuOpen = false;
  ngOnInit() {
    if (this.client) {
      this.userName = this.authService.currentUser$()?.name;
      this.updateTitle(this.router.url);
      // Mettre à jour à chaque changement de route
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.updateTitle(event.urlAfterRedirects);
        });
    }
  }
  updateTitle(path: string) {
    const menuItems = this.menuService.getMenuItems();

    // Fonction utilitaire pour matcher les routes avec paramètres dynamiques
    const matchRoute = (actualPath: string, routePattern: string): boolean => {
      // Remplace ":quelquechose" par une partie dynamique dans la regex
      const regexPattern = '^' + routePattern.replace(/:[^/]+/g, '[^/]+') + '$';
      const regex = new RegExp(regexPattern);
      return regex.test(actualPath);
    };

    const findLabel = (items: MenuItem[]): string | undefined => {
      for (const item of items) {
        if (matchRoute(path, item.route)) {
          return item.label;
        }
        if (item.children) {
          for (const child of item.children) {
            if (matchRoute(path, child.route)) {
              return child.label;
            }
          }
        }
      }
      return undefined;
    };

    this.pageTitle = findLabel(menuItems) ?? 'Questionnaire';
  }
  goToProfile() {
    // rediriger vers /profil ou similaire
    this.router.navigate(['/profil']);
  }
  logout() {
    this.authService.logout();
  }
  redirectSite() {
    window.open(environment.host);
  }
}
